import * as React from 'react';

import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {ExternalMeetingFragment} from 'nutshell-graphql-types';

import {MeetingsTable} from './meetings-table';
import type {ExternalServiceTypeFrontend} from './tables/types';
import {UnloggedTableEmptyState} from './tables/unlogged-table-empty-state';

type Props = {
    meetings: ExternalMeetingFragment[];
    onAssociateMeetingWithActivity: (id: string) => Promise<any>;
    onRemoveMeeting: (id: string) => Promise<any>;
    fetchNextPage: () => Promise<any>;
    fetchPreviousPage: () => Promise<any>;
    totalCount: number;
    pageSize: number;
    isLoading: boolean;
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    hasLoggedMeetings: boolean;
    isPerformingInitialSync: boolean;
    firstEnabledIntegrationType: ExternalServiceType | null | undefined;
    shouldShowSummaryColumn: boolean;
};

export function UnloggedMeetingsTable(props: Props) {
    return (
        <MeetingsTable
            meetings={props.meetings}
            onAssociateMeetingWithActivity={props.onAssociateMeetingWithActivity}
            onRemoveMeeting={props.onRemoveMeeting}
            fetchNextPage={props.fetchNextPage}
            fetchPreviousPage={props.fetchPreviousPage}
            totalCount={props.totalCount}
            pageSize={props.pageSize}
            isLoading={props.isLoading}
            serviceType={props.serviceType}
            shouldShowSummaryColumn={props.shouldShowSummaryColumn}
            emptyState={
                <UnloggedTableEmptyState
                    totalCount={props.totalCount}
                    isPerformingInitialSync={props.isPerformingInitialSync}
                    firstEnabledIntegrationType={props.firstEnabledIntegrationType}
                    serviceType={props.serviceType}
                    hasLoggedMeetings={props.hasLoggedMeetings}
                    meetings={props.meetings}
                />
            }
        />
    );
}
